import React from 'react';
import {
  TooltipWrapper, TooltipHeader, TooltipTitle, StepCounter,
  TooltipContent, TooltipFooter, SkipButton, NavButtons, BackButton, NextButton,
} from './TutorialTooltip.styles';

const TutorialTooltip = ({
  continuous,
  index,
  step,
  size,
  backProps,
  primaryProps,
  skipProps,
  isLastStep,
  tooltipProps,
}) => (
  <TooltipWrapper {...tooltipProps}>
    <TooltipHeader>
      <TooltipTitle>{step.title}</TooltipTitle>
      <StepCounter>{index + 1} of {size}</StepCounter>
    </TooltipHeader>
    <TooltipContent>{step.content}</TooltipContent>
    <TooltipFooter>
      {!isLastStep ? (
        <SkipButton {...skipProps}>Skip Tour</SkipButton>
      ) : <span />}
      <NavButtons>
        {index > 0 && <BackButton {...backProps}>Back</BackButton>}
        <NextButton {...primaryProps} $isLast={isLastStep}>
          {isLastStep ? 'Get Started!' : 'Next'}
        </NextButton>
      </NavButtons>
    </TooltipFooter>
  </TooltipWrapper>
);

export default TutorialTooltip;
